import * as React from 'react';
import type {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import type {Asset} from '@deviceinsight/ng-ui-api-client';
import DeviceAndActionIcon from '../../../components/common/DeviceAndActionIcon';
import {ACTION_TYPE_DEVICE} from '../../ruleengine/config/consts';

const columnDefs = (): Array<ReactableColumnDef<Asset>> => {
	return [
		{
			name: 'name',
			label: {
				id: 'asset.name',
				defaultValue: 'Name'
			},
			sortable: true,
			render: (asset) => (
				<span>
					<DeviceAndActionIcon asset={asset} type={ACTION_TYPE_DEVICE} small />
					{asset.name}
				</span>
			),
			width: '50%'
		},
		{
			name: 'urn',
			label: {
				id: 'asset.urn',
				defaultValue: 'urn'
			},
			sortable: true,
			render: (asset) => asset.urn,
			width: '40%'
		}
	];
};

export default columnDefs;
